import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'sleep',
    },
  },
  {
    name: 'sleep',
    path: '/sleep/:year?/:month?/:day?',
    component: () => import('./view/sleep'),
    meta: {
      title: '睡眠报告',
      titleNeedTranslate: false
    },
  },
  {
    name: 'openSleep',
    path: '/openSleep/:wwid/:year/:month/:day/:vpaToken',
    component: () => import('./view/openSleep'),
    meta: {
      title: '睡眠报告',
      titleNeedTranslate: false
    },
  },
  {
    name: 'sleepDataCompare',
    path: '/sleepDataCompare/:year?/:month?/:day?',
    component: () => import('./view/sleepDataCompare'),
    meta: {
      title: '睡眠数据比对',
      titleNeedTranslate: true
    },
  },
  {
    name: 'snoreData',
    path: '/snoreData/:year?/:month?/:day?',
    component: () => import('./view/snore/SnoreData'),
    meta: {
      title: '鼾声数据',
      titleNeedTranslate: true
    },
  },
  {
    name: 'snoreRecord',
    path: '/snoreRecord',
    component: () => import('./view/snore/SnoreRecord'),
    meta: {
      title: '鼾声记录',
      titleNeedTranslate: true
    },
  },
  {
    name: 'setting',
    path: '/setting/index',
    component: () => import('./view/snore/settings/index.vue'),
    meta: {
      title: '鼾声记录设置',
      titleNeedTranslate: true
    },
  },
  {
    name: 'storageDuration',
    path: '/setting/storage/duration',
    component: () => import('./view/snore/settings/storageDuration.vue'),
    meta: {
      title: '鼾声记录设置',
      titleNeedTranslate: true
    },
  },
  {
    name: 'storageLocation',
    path: '/setting/storage/location',
    component: () => import('./view/snore/settings/storageLocation.vue'),
    meta: {
      title: '鼾声记录设置',
      titleNeedTranslate: true
    },
  },
  {
    name: 'openVip',
    path: '/openVip',
    component: () => import('./view/openVip'),
    meta: {
      title: '开通会员',
      titleNeedTranslate: true
    },
  },
  {
    name: 'myVip',
    path: '/myVip',
    component: () => import('./view/myVip'),
    meta: {
      title: '我的会员',
      titleNeedTranslate: true
    },
  },
  {
    name: 'payResult',
    path: '/pay-result',
    component: ()=> import('./view/payResult'),
    meta: {
      title: '支付结果',
      titleNeedTranslate: false
    },
  },
  {
    name: 'advert',
    path: '/advert/index',
    component: () => import('./view/advert/index'),
    meta: {
      title: '睡眠会员',
      titleNeedTranslate: true
    },
  },
  {
    name: 'advertDetail',
    path: '/advert/detail',
    component: () => import('./view/advert/detail'),
    meta: {
      title: '会员功能说明',
      titleNeedTranslate: true
    },
  },

  {
    name: 'affiliateNotice',
    path: '/docs/affiliate-notice',
    component: () => import('./view/docs/affiliate-notice.vue'),
    meta: {
      title: 'Corporate Affiliates Notice',
    titleNeedTranslate: true
    }
  },
  {
    name: 'cookiePolicy',
    path: '/docs/cookie-policy',
    component: () => import('./view/docs/cookie-policy.vue'),
    meta: {
      title: 'cookie-policy',
      titleNeedTranslate: true
    }
  },
  {
    name: 'privacyPolicy',
    path: '/docs/privacy-policy',
    component: () => import('./view/docs/privacy-policy.vue'),
    meta: {
      title: 'privacy-policy',
    titleNeedTranslate: true
    }
  },
  {
    name: 'termsOfService',
    path: '/docs/terms-of-service',
    component: () => import('./view/docs/terms-of-service.vue'),
    meta: {
      title: 'terms-of-service',
    titleNeedTranslate: true
    }
  },
  {
    name: 'test',
    path: '/test',
    component: ()=> import('./view/test'),
    meta: {
      title: '测试',
      titleNeedTranslate: false
    },
  }
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  document.title='\u200E';
  const title = to.meta && to.meta.title;
  const titleNeedTranslate = to.meta && to.meta.titleNeedTranslate;
  if(!titleNeedTranslate && title){
    document.title = title;
  }
  next();
});

export { router };

